import { CoreApi } from '@inter-ikea-storageone/range';
import { PanelArrangement } from '@inter-ikea-storageone/range-pax';
import getPanelArrangement from './getPanelArrangement';

const hasPanelArrangementSolid: (coreApi: CoreApi, selectedEntityId: number) => boolean = (
  coreApi,
  selectedEntityId
) => {
  const doorEntity = coreApi.entities.find(selectedEntityId);
  if (!doorEntity) {
    return false;
  }
  return getPanelArrangement(doorEntity, coreApi) === PanelArrangement.Solid;
};

export default hasPanelArrangementSolid;
